<template>
  <div :id="id" class="p-8 bg-white rounded-xl">
    <div
      class="gap-6"
      :class="[
        gridColsClass,
        formData.isUseSliderOnMobile ? 'hidden md:grid' : 'grid',
      ]"
    >
      <template
        v-for="(url, index) in formData.images"
        :key="'images-grid' + url + index"
      >
        <div class="w-full">
          <img :src="url" class="w-full rounded-xl" />
        </div>
      </template>
    </div>
    <div :class="formData.isUseSliderOnMobile ? 'block md:hidden' : 'hidden'">
      <Swiper
        :slides-per-view="'auto'"
        :space-between="SLIDES_GAP"
        :pagination="{
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 10,
        }"
        :modules="swiperModules"
        class="swiper-custom"
      >
        <template
          v-for="(url, index) in formData.images"
          :key="'images-slider' + url + index"
        >
          <SwiperSlide
            :style="{
              marginRight: SLIDES_GAP + 'px',
              width: getSlideWidth(formData.colsNumberOnMobile, SLIDES_GAP),
            }"
          >
            <div class="w-full">
              <img :src="url" class="w-full rounded-xl" />
            </div>
          </SwiperSlide>
        </template>
      </Swiper>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Grid, Pagination } from 'swiper/modules'
import { getGridColsClass, getSlideWidth } from '../utils'
import 'swiper/css'
import 'swiper/css/grid'
import 'swiper/css/pagination'

interface FormDataInterface {
  colsNumberOnDesktop: number
  colsNumberOnMobile: number
  isUseSliderOnMobile: boolean
  rowsNumberInSliderOnMobile: number
  images: string[]
}

interface PropsInterface {
  formData: FormDataInterface
  id: string
}

const SLIDES_GAP = 24
const props = withDefaults(defineProps<PropsInterface>(), {
  formData: () => ({
    colsNumberOnDesktop: 4,
    colsNumberOnMobile: 2,
    isUseSliderOnMobile: true,
    rowsNumberInSliderOnMobile: 1,
    images: [],
  }),
})

const swiperModules = [Grid, Pagination]

const gridColsClass = computed(() => {
  return getGridColsClass(
    props.formData.colsNumberOnDesktop,
    props.formData.colsNumberOnMobile
  )
})
</script>
